/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface EmergencyContactInfoVO {
  /**
   * phone country code of emergency contact person
   */
  countryCode?: string;
  /**
   * first name of emergency contact person
   */
  firstName?: string;
  /**
   * last name of emergency contact person
   */
  lastName?: string;
  /**
   * phone number of emergency contact person
   */
  phoneNumber?: string;
}
